module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "text"
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onKeyDown($event)
      },
      "input": _vm.onInput
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6805d67f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/phone.vue
// module id = 419
// module chunks = 0